module.exports = __webpack_public_path__ + "static/media/bank-api-logo-notext.674cf3be.svg";